<template>
  <!-- 마이페이지 > 문헌 업로드 토큰 (Thermax LitTokenPanel 대응) — 웹 로그인 전용 -->
  <div>
    <MypageSubTitle />
    <div class="ptc_container lit-token">
      <h3 class="form_tit first">문헌 업로드 토큰</h3>
      <p class="lit-help">
        팀 PC 의 스크립트(<code>lit_register.py</code>, <code>lit_push.py</code>)가 이 토큰으로 문헌 수집 API 에 접속합니다.
        토큰은 <b>발급 직후 한 번만</b> 보이며, 다시 볼 수 없습니다. 분실하면 폐기하고 새로 발급하세요.
        토큰은 개인 것이며 문서·저장소·대화에 적지 않습니다.
      </p>

      <div class="lit-issue">
        <label>라벨 (선택) <input type="text" v-model="label" maxlength="100" placeholder="예: 연구실 PC"></label>
        <label>유효기간
          <select v-model.number="days">
            <option :value="90">90일</option>
            <option :value="180">180일</option>
            <option :value="365">365일</option>
          </select>
        </label>
        <button type="button" class="sm_btn" :disabled="busy" @click="issue">토큰 발급</button>
      </div>

      <div class="lit-new" v-if="issued">
        <div class="lit-new-head">지금 한 번만 표시됩니다 — 복사해서 환경 변수 <code>{{ envName }}</code> 에 넣으세요.</div>
        <div class="lit-new-token">
          <code>{{ issued.token }}</code>
          <button type="button" class="sm_btn" @click="copy(issued.token)">{{ copied ? '복사됨' : '복사' }}</button>
        </div>
        <button type="button" class="lit-new-close" @click="issued = null">확인했습니다 (닫기)</button>
      </div>

      <table class="lit-table" v-if="tokens.length">
        <thead><tr><th>토큰</th><th>라벨</th><th>만료일</th><th>최근 사용</th><th>상태</th><th></th></tr></thead>
        <tbody>
        <tr v-for="t in tokens" :key="t.id" :class="{ dead: !t.active }">
          <td class="mono">{{ t.token_prefix }}…</td>
          <td>{{ t.label || '—' }}</td>
          <td class="mono">{{ fmt(t.expires_at) }}</td>
          <td class="mono">{{ t.last_used_at ? fmt(t.last_used_at) : '사용 전' }}</td>
          <td>
            <span v-if="t.revoked_at" class="lit-badge">폐기됨 {{ fmt(t.revoked_at) }}</span>
            <span v-else-if="!t.active" class="lit-badge">만료</span>
            <span v-else class="lit-badge on">사용 중</span>
          </td>
          <td><button v-if="t.active" type="button" class="sm_btn" :disabled="busy" @click="revoke(t)">폐기</button></td>
        </tr>
        </tbody>
      </table>
      <p v-else-if="loaded" class="lit-help">발급된 토큰이 없습니다.</p>

      <h3 class="form_tit">사용 예시 (curl)</h3>
      <pre class="lit-pre">{{ curlExample }}</pre>
      <p class="lit-help">
        서버 주소는 <code>{{ apiBase }}/lit-api/…</code> 입니다. 응답은 <code>{{ responseShape }}</code> 이며 실제 결과는 <code>data</code> 안에 있습니다.
      </p>
      <p class="lit-error" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import MypageSubTitle from "@/views/Platform/Account/MypageSubTitle";

export default {
  name: "LitTokenPanel",
  components: { MypageSubTitle },
  data() {
    return { tokens: [], loaded: false, busy: false, error: null, label: "", days: 180, issued: null, copied: false };
  },
  computed: {
    envName() {
      const base = process.env.BASE_URL || "/";
      return base.indexOf("battery") >= 0 ? "KESHHUB_LIT_TOKEN" : "M3DHUB_LIT_TOKEN";
    },
    curlExample() {
      return 'curl -s ' + this.apiBase + '/lit-api/me -H "Authorization: Bearer ${' + this.envName + '}"';
    },
    responseShape() {
      return '{"code":200,"message":"…","data":{…}}';
    },
    apiBase() {
      const env = process.env.VUE_APP_API_BASE;
      if (env) return env.replace(/\/$/, "") + "/v1";
      const base = (process.env.BASE_URL || "/").replace(/\/$/, "");
      return `${window.location.origin}${base}/soap/api/v1`;
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      const res = await this.$wApi.lit.tokens.list();
      this.loaded = true;
      if (!res || res.error) { this.error = (res && res.message) || "토큰 목록을 불러오지 못했습니다."; return; }
      this.tokens = res;
    },
    async issue() {
      this.busy = true; this.error = null; this.copied = false;
      const res = await this.$wApi.lit.tokens.create({ label: this.label, days: this.days });
      this.busy = false;
      if (!res || res.error) { this.error = (res && res.message) || "발급에 실패했습니다."; return; }
      this.issued = res;
      this.label = "";
      await this.load();
    },
    async revoke(t) {
      if (!window.confirm(`토큰 ${t.token_prefix}… 을 폐기하시겠습니까? 이 토큰을 쓰는 스크립트는 즉시 401 이 됩니다.`)) return;
      this.busy = true;
      const res = await this.$wApi.lit.tokens.revoke({}, t.id);
      this.busy = false;
      if (res && res.error) { this.error = res.message || "폐기에 실패했습니다."; return; }
      await this.load();
    },
    async copy(text) {
      try { await navigator.clipboard.writeText(text); this.copied = true; }
      catch (e) { window.prompt("복사해서 사용하세요:", text); }
    },
    fmt(iso) {
      return iso ? String(iso).replace("T", " ").slice(0, 16) : "";
    },
  },
};
</script>

<style scoped>
.lit-help { font-size: 13px; color: #556; line-height: 1.6; margin: 8px 0 14px; }
.lit-help code, .lit-new code { background: #f4f7fa; padding: 1px 5px; border-radius: 3px; font-family: Consolas, "Courier New", monospace; }
.lit-issue { display: flex; flex-wrap: wrap; gap: 14px; align-items: flex-end; margin-bottom: 16px; font-size: 13px; }
.lit-issue label { display: flex; flex-direction: column; gap: 4px; color: #445; }
.lit-issue input, .lit-issue select { height: 32px; border: 1px solid #cfd8e3; border-radius: 4px; padding: 0 8px; min-width: 200px; }
.lit-new { border: 1px solid #f0c36d; background: #fff8e6; border-radius: 6px; padding: 12px 14px; margin-bottom: 16px; }
.lit-new-head { font-size: 13px; color: #7a5200; margin-bottom: 8px; }
.lit-new-token { display: flex; gap: 8px; align-items: center; }
.lit-new-token code { font-size: 14px; word-break: break-all; background: #fff; border: 1px solid #f0c36d; padding: 6px 10px; border-radius: 4px; }
.lit-new-close { margin-top: 10px; background: none; border: none; color: #7a5200; text-decoration: underline; cursor: pointer; font-size: 12px; }
.lit-table { width: 100%; border-collapse: collapse; font-size: 13px; border-top: 2px solid #003f67; margin-bottom: 20px; }
.lit-table th { background: #f4f7fa; padding: 9px 8px; text-align: left; border-bottom: 1px solid #dde3ea; }
.lit-table td { padding: 8px; border-bottom: 1px solid #eef1f5; }
.lit-table tr.dead td { color: #aab; }
.mono { font-family: Consolas, "Courier New", monospace; font-size: 12px; }
.lit-badge { display: inline-block; padding: 2px 8px; border-radius: 999px; font-size: 11px; background: #eef1f5; color: #667; }
.lit-badge.on { background: #e3f6ea; color: #1f7a3f; }
.lit-pre { background: #1e2a36; color: #e6edf3; padding: 10px 12px; border-radius: 6px; font-size: 12px; overflow-x: auto; }
.lit-error { color: #b23; }
</style>
